<template lang='pug'>
  .div
    template(v-if="!visual")
      .only-two-info(v-if="width >= 768")
        .column.has-text-centered.suport-email-only-two
          template
            p
              | {{ $t('componentes.footer.duvidasAcesse') }} &nbsp;
              a.has-link(href="https://suporte.pontotel.com.br/") suporte.pontotel.com.br

        .column.has-text-centered
          p PontoTel | {{ $t('componentes.footer.direitosReservados') }}: {{ version }}
      .row.has-text-centered.suport-email(v-else)
          template
            p
              | {{ $t('componentes.footer.duvidasAcesse') }} &nbsp;
              a.has-link(href="https://suporte.pontotel.com.br/") suporte.pontotel.com.br
          .row.has-text-centered
              p PontoTel | {{ $t('componentes.footer.direitosReservados') }}: {{ version }}
    template(v-else)
      .only-two-info(v-if="width >= 768 && !visual.webIgnoreSupportMessage")
        .column.has-text-centered.suport-email-only-two
          template(v-if='visual.supportEmail !== "suporte@pontotel.com.br"')
            p
              | Dúvidas? Mande um e-mail para &nbsp;
              a.has-link {{visual.supportEmail}}
              template(v-if="deviceId && visual.webShowBrowserRecord")
                p &nbsp; {{ $t('componentes.footer.codigoColetor') }}: &nbsp;
                  strong {{ deviceId }}
          template(v-if='visual.supportEmail === "suporte@pontotel.com.br"')
            p
              | {{ $t('componentes.footer.duvidasAcesse') }} &nbsp;
              a.has-link(href="https://suporte.pontotel.com.br/") suporte.pontotel.com.br
            template(v-if="deviceId && visual.webShowBrowserRecord")
              p &nbsp; {{ $t('componentes.footer.codigoColetor') }}: &nbsp;
                strong {{ deviceId }}

        .column.has-text-centered
          p PontoTel | {{ $t('componentes.footer.direitosReservados') }}: {{ version }}

      footer(v-if="width >= 768 && visual.webIgnoreSupportMessage")
        .column.has-text-centered.system-center
          p PontoTel | {{ $t('componentes.footer.direitosReservados') }}: {{ version }}

      footer(v-else-if="width < 768")
        .row.has-text-centered.suport-email(v-if="!visual.webIgnoreSupportMessage")
          template(v-if='visual.supportEmail !== "suporte@pontotel.com.br"')
            p
              | Dúvidas? Mande um e-mail para &nbsp;
              a.has-link {{visual.supportEmail}}
              template(v-if="deviceId && visual.webShowBrowserRecord")
                p &nbsp; Código do dispositivo: &nbsp;
                  strong {{ deviceId }}
          template(v-if='visual.supportEmail === "suporte@pontotel.com.br"')
            p
              | {{ $t('componentes.footer.duvidasAcesse') }} &nbsp;
              a.has-link(href="https://suporte.pontotel.com.br/") suporte.pontotel.com.br
              p(v-if="deviceId && visual.webShowBrowserRecord") &nbsp; Código do dispositivo: &nbsp;
                strong {{ deviceId }}

        .row.has-text-centered
          p PontoTel | {{ $t('componentes.footer.direitosReservados') }}: {{ version }}
</template>
<script>
import config from '../../config'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      version: config.version,
      width: 0,
      compManId: this.$store.state.accessData.compManId
    }
  },
  created () {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  },
  computed: {
    ...mapGetters(['visual']),
    deviceId () {
      return this.$store.state.accessData.coletor.coletorId || false
    },
    isBV () {
      if (this.$store.state.accessData && this.$store.state.accessData.compMan) {
        return this.$store.state.accessData.compMan.id === '5cd49411d28021000c09e013'
      } else {
        return false
      }
    },
    isNubank () {
      if (this.$store.state.accessData && this.$store.state.accessData.compMan) {
        return this.$store.state.accessData.compMan.id === '56d7358536a3b600dc7e2b3e'
      } else {
        return false
      }
    }
  },
  methods: {
    goToApp () {
      if (location.href.includes('localhost')) {
        window.location.replace('http://localhost:8081')
      } else if (location.href.includes('hml.pontotel.com.br/pontotel/new-web')) {
        if (this.isBV) {
          window.location.replace('https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/app/BancoVotorantim')
        } else if (this.isNubank) {
          window.open('https://hml.pontotel.com.br/pontotel/back/api/redirect-saml/app/nubank-pontotel', '_blank')
        } else {
          window.location.replace('https://homolog.pontotel.com.br')
        }
      } else if (location.href.includes('new-web.pontotel.com.br')) {
        if (this.isBV) {
          window.location.replace('https://back.pontotel.com.br/api/redirect-saml/app/BancoVotorantim')
        } else if (this.isNubank) {
          window.open('https://back.pontotel.com.br/api/redirect-saml/app/nubank-pontotel', '_blank')
        } else {
          window.location.replace('https://gestao.pontotel.com.br')
        }
      }
    },
    handleResize () {
      this.width = window.innerWidth
      if (this.width < 768) {
        this.toggle = false
      }
    }
  }
}
</script>

<style scoped>
footer {
  display: grid;
  align-items: center;
  font-size: 13px;
}

@media only screen and (min-width: 320px)  {

  footer {
    padding: 5% 1% 0% 1%;
    display: grid;
    grid-template-rows: 1fr 1fr 2fr;
  }

  .button-style{
    margin-bottom: 2%;
  }
}

@media (min-width: 768px) {

  footer {
    padding: 0% 1% 0 1%;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: 1fr;
  }

  .only-two-info {
    padding: 0 auto;
    display: grid;
    grid-template-columns: 0.5fr 0.5fr;
  }

  .suport-email-only-two {
    grid-column-start: 1;
  }

  .system-center {
    grid-column-start: 2;
  }
  .suport-email {
    grid-column-start: 3;
  }
}

@media (min-width: 960px) {

  img.re-mobile {
    max-width: 140px;
    max-height: 80px;
  }

  img.re-mobile.client {
    max-width: 140px;
    max-height: 60px;
    min-height: 35px;
  }
}

@media only screen and (min-width: 1024px) {
  img.re-mobile {
    max-width: 200px;
    max-height: 80px;
  }

  img.re-mobile.client {
    max-width: 200px;
    max-height: 60px;
    min-height: 35px;
  }
}

@media only screen and (min-width: 1900px) {
  img.re-mobile {
    max-width: 180px;
    max-height: 80px;
  }

  img.re-mobile.client {
    max-width: 180px;
    max-height: 60px;
    min-height: 35px;
  }
}
</style>
